import React, { useState } from 'react';
import { BottomNav, MobileTab } from './BottomNav';
import { PhoneFrame } from './PhoneFrame';
import { AboutScreen } from './free/AboutScreen';
import { CurriculumScreen } from './free/CurriculumScreen';
import { LanguageScreen } from './free/LanguageScreen';
import { QrScannerScreen } from './free/QrScannerScreen';
import { SearchScreen } from './free/SearchScreen';
import { ChatScreen } from './webview/ChatScreen';
import { FamilyWebView } from './webview/FamilyWebView';
import { JoinProjectScreen } from './webview/JoinProjectScreen';
import { Lang } from '../../lib/assets';
type FreeScreen = 'language' | 'about' | 'curriculum';
export function MobilePreview() {
  const [lang, setLang] = useState<Lang>('en');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [tab, setTab] = useState<MobileTab>('home');
  const [freeScreen, setFreeScreen] = useState<FreeScreen>('language');
  const selectTab = (next: MobileTab) => {
    setTab(next);
  };
  const completeAuthentication = () => {
    setIsAuthenticated(true);
    setTab('home');
  };
  const signOut = () => {
    setIsAuthenticated(false);
    setTab('family');
  };
  const familyView = <FamilyWebView lang={lang} isAuthenticated={isAuthenticated} openProfile={isAuthenticated && tab === 'family'} onAuthenticated={completeAuthentication} onJoinProject={() => setTab('project')} onProfileClosed={() => setTab('home')} onSignOut={signOut} data-id="element-129" data-mp="2ld5qlyvqen3o" />;
  const authenticatedContent = tab === 'search' ? <SearchScreen data-id="element-130" data-mp="2qbpbdvyl9sug" /> : tab === 'qr' ? <QrScannerScreen onClose={() => setTab('home')} onScanComplete={() => setTab('home')} data-id="element-131" data-mp="350valjxffj2c" /> : tab === 'project' ? <JoinProjectScreen onBack={() => setTab('home')} data-id="element-132" data-mp="301s55ydjbatu" /> : tab === 'chat' ? <ChatScreen onBack={() => setTab('home')} data-id="element-133" data-mp="3e19zet9lngal" /> : familyView;
  return <div className="flex w-full flex-col items-center gap-4" data-id="element-134" data-mp="392q78b4ex89s">
      <PhoneFrame data-id="element-135" data-mp="394jjq71pimpp">
        {isAuthenticated ? <>
            <div className="min-h-0 flex-1 overflow-hidden" data-id="element-136" data-mp="26q3kqj7ai7g8">{authenticatedContent}</div>
            <BottomNav active={tab} onChange={selectTab} variant="authenticated" data-id="element-137" data-mp="2bnvi3sqpelrt" />
          </> : <>
            <div className="min-h-0 flex-1 overflow-hidden" data-id="element-138" data-mp="2fp729iqt6esm">
              {tab === 'family' && familyView}
              {tab === 'home' && freeScreen === 'language' && <LanguageScreen lang={lang} onSelect={setLang} onContinue={() => setFreeScreen('about')} data-id="element-139" data-mp="2pg20zml8r6uy" />}
              {tab === 'home' && freeScreen === 'about' && <AboutScreen onBack={() => setFreeScreen('language')} onNext={() => setFreeScreen('curriculum')} data-id="element-140" data-mp="2udblqoxoqucg" />}
              {tab === 'home' && freeScreen === 'curriculum' && <CurriculumScreen onBack={() => setFreeScreen('about')} onNext={() => setTab('search')} data-id="element-141" data-mp="33g2yqt67ly67" />}
              {tab === 'search' && <SearchScreen data-id="element-142" data-mp="1519s7jhfreby" />}
            </div>
            <BottomNav active={tab} onChange={selectTab} variant="guest" data-id="element-143" data-mp="191k0j2spagtz" />
          </>}
      </PhoneFrame>
      <button onClick={() => {
      setLang('en');
      setIsAuthenticated(false);
      setTab('home');
      setFreeScreen('language');
    }} className="rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-600 shadow-sm ring-1 ring-slate-200" data-id="element-144" data-mp="11hr9ltyghvrf">Reset prototype</button>
    </div>;
}